module.exports = __webpack_public_path__ + "static/media/WordMark_eng_jpg.b70f7739.jpg";